(function () {

  function youtubeInit() {
    document.querySelectorAll('.youtube-container').forEach(container => {
      container.addEventListener('click', () => {
        // Only add an iframe if there isn't one already
        if (!container.querySelector('iframe')) {
          // Remove only iframes from all other containers and show images
          document.querySelectorAll('.youtube-container').forEach(otherContainer => {
            if (otherContainer !== container) {
              const iframes = otherContainer.querySelectorAll('iframe');
              iframes.forEach(iframe => iframe.remove());
              // Remove 'hidden' class from images
              otherContainer.querySelectorAll('img').forEach(img => {
                img.classList.remove('hidden');
              });
            }
          });
          // Hide images in the current container
          container.querySelectorAll('img').forEach(img => {
            img.classList.add('hidden');
          });
          const videoId = container.getAttribute('data-id');
          const iframe = document.createElement('iframe');
          iframe.setAttribute('src', `https://www.youtube.com/embed/${videoId}?autoplay=1`);
          iframe.setAttribute('frameborder', '0');
          iframe.setAttribute('allowfullscreen', '1');
          iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
          iframe.style.width = "100%";
          iframe.style.height = "100%";
          container.appendChild(iframe);
        }
      });
    });
  }

  document.addEventListener("shopify:section:load", function (e) {
    youtubeInit();
  });

  youtubeInit();
})();
